export enum MediaType {
  VIDEO = 'video',
  AUDIO = 'audio',
  IMAGE = 'image',
  PDF = 'pdf',
  CONVERTIBLEIMAGE = 'convertibleImage',
  OFFICEDOC = 'officeDoc',
  POWERPOINT = 'powerpoint',
  KEYNOTE = 'keynote',
  OTHER = 'other',
}

export enum FileTranscodingStatus {
  IDLE = 'idle',
  IN_PROGRESS = 'in-progress',
  SUCCESS = 'success',
  FAILED = 'failed',
}
